<template>
    <div class="_companyinfo">
        <Spin v-if="pageLoading" fix size="large"></Spin>
        <div class="head">
            <span class="title">单位编辑</span>
        </div>
        <div v-if="pageAuth===true">

            <Form ref="partoneForm" label-position="top" :inline="true" :model="formData" :rules="rule">
                <Row>
                    <Col span="9" class="_company_edit_company_name_">
                        <FormItem prop="companyname" style="width: 100%">
                            <label slot="label" class="label-title">单位名称<span class="start" style="color: #ed3f14">*</span></label>
                            <Input type="text" disabled  v-model="formData.companyname"></Input>
                        </FormItem>
                    </Col>
                    <Col span="4" offset="2">
                        <FormItem prop="aliases" style="width: 100%">
                            <label slot="label" class="label-title">别名<span-tip :content="'（多个别名请用逗号或空格隔开）'"></span-tip></label>
                            <Input type="text" v-model="formData.aliases" placeholder="请填写别名"></Input>
                        </FormItem>
                    </Col>
                    <Col span="3" offset="1" :style="{width:'135px'}">
                        <FormItem label="LOGO" prop="logo" style="width: 100%">
                            <label slot="label" class="label-title">LOGO<span-tip :content="'（200px*150px）'"></span-tip></label>
                            <input type="hidden" v-model="formData.logo" style="display: none" />
                            <Upload :action="uploadUrl" :headers="uploadHeader" name="file[]" :show-upload-list="false" :on-success="(response)=>{logoUploadSuccess(response)}" :on-error="logoUploadError">
                                <Button icon="ios-cloud-upload-outline" :style="{width:'100%',padding:'6px 10px',fontWeight:'100'}">点击上传LOGO</Button>
                            </Upload>
                        </FormItem>
                    </Col>
                    <Col span="2" :style="{marginLeft:'25px'}">
                        <div class="logo-border">
                            <img :src="formData.logo" :onerror="'this.src=\''+ require('@/assets/images/default-logo.jpg')+'\'' " />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span="9">
                    <FormItem label="手机号码" prop="mobile" style="width: 100%">
                        <label slot="label" class="label-title">手机号码<span class="start">*</span><span-tip :content="'（手机/座机至少填一个）'"></span-tip></label>
                        <Input type="text" v-model="formData.mobile" placeholder="请填写手机号" ></Input>
                    </FormItem>
                    </Col>
                    <Col span="9" offset="2">
                    <FormItem class="phone-input-box" label="座机号码" prop="phone" style="width: 100%;white-space: nowrap">
                        <label slot="label" class="label-title">座机号码<span class="start">*</span><span-tip :content="'（手机/座机至少填一个）'"></span-tip></label>
                        <input type="text" class="ivu-input"  v-model="formData.phone[0]" placeholder="请填写区号" style="width:calc( 33.33333% - 20px );border-top-right-radius: 0;border-bottom-right-radius: 0"/>
                        <input type="text" class="ivu-input line"  value=" - " disabled />
                        <input type="text" class="ivu-input"  v-model="formData.phone[1]" placeholder="请填写座机号" style="width:calc( 33.33333% - 20px );border-radius: 0"/>
                        <input type="text" class="ivu-input line"  value=" - " disabled />
                        <input type="text" class="ivu-input"  v-model="formData.phone[2]" placeholder="请填写分机号" style="width:calc( 34.2% - 20px );border-top-left-radius: 0;border-bottom-left-radius: 0"/>
                    </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="单位介绍" prop="intro" style="width: 100%">
                            <Input type="textarea" :rows="6"  v-model="formData.intro" placeholder="请填写单位介绍" ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="图片上传" style="width: 100%">
                            <label slot="label" class="label-title">上传图片<span-tip :content="'（用于展示单位，图片格式为JPG、PNG，且图片大小不得超过5MB，点击图片选择封面图，默认为第一张）'"></span-tip></label>
                            <file-upload
                                ref="companyPic"
                                :uploadUrl="uploadUrl"
                                :limit-type="['jpg','png','jpeg']"
                                :max-size="5120"
                                :selected-mode="true">
                            </file-upload>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem>
                    <Button class="save-part-btn" type="primary" @click="doSave" :loading="loadingStatus">保存</Button>
                </FormItem>
            </Form>
        </div>
        <span style="clear: both"></span>
    </div>
</template>

<script>
    import editValidate from "@/validateRule/company/editCompany";
    import baseAuthEnum from "@/staticData/baseAuthEnum";
    import Config from '@/config.js';
    import $api from "@/service/index";
    import utils from "@/utils";
    import spanTip from "@/components/labelTip/labelTip.vue";
    import FileUpload from "@/components/upload/Upload";
    import Cookies from 'js-cookie';

    export default {
        components:{
            spanTip,
            FileUpload,
        },
        data(){
            return {
                initPicStatus : false, //初始化证明资料图标是否成功标志位
                loadingStatus : false,  //按钮loaing状态
                pageLoading : true,
                rule : {},    //表单雁阵规则
                pageAuth : false,   //编辑单位的权限
                baseData : [],      //单位基本信息
                formData : {
                    phone : ['', '', '']
                },      //表单数据
                companyId : "0",    //单位id
                type : "0",         //单位类型,
                companyMaterial: Config.companyMaterial,   //单位证明资料模板资源url
                uploadUrl :     Config.apiUrl+"/upload",    //图片上传地址
                //上传请求header
                uploadHeader: {
                    token: Cookies.get('token'),
                    theOne: Cookies.get('theOne'),
                    source: 'web',
                    uid: Cookies.get('uid')
                },
                picList : [],
            }
        },
        filters : {
        },
        watch: {
            'formData.phone'(newVal, oldVal){
                this.$refs.partoneForm.validate();
            },
            'formData.mobile'(newVal, oldVal){
                this.$refs.partoneForm.validate();
            },
        },
        created(){
            //获取权限
            this.getPageAuth();
            //单位基本信息
            this.getCompanyBaseInfo();
        },
        methods : {
            //设置正确的表单验证规则
            setFormRule(){
                this.rule = {
                    mobile : {},
                    phone : {},
                };
                let _self = this;
                //手机座机至少填写一个
                this.rule.mobile = {
                    validator: (rule, value, callback) => {
                        if(!_self.formData.mobile || _self.formData.mobile===""){
                            if( _self.formData.phone[0]==="" && _self.formData.phone[1]==="" && _self.formData.phone[2]==="" ){
                                callback(new Error("手机和座机至少填写一个"));
                            }
                        }
                        if(_self.formData.mobile !== '' && !utils.isPhoneNum(_self.formData.mobile)){
                            callback(new Error("请填写正确的手机号"));
                        }
                        callback();
                    },
                };
                this.rule.phone = {
                    validator: (rule, value, callback) => {
                        if(!_self.formData.mobile || _self.formData.mobile===""){
                            if( _self.formData.phone[0]==="" && _self.formData.phone[1]==="" && _self.formData.phone[2]===""){
                                callback(new Error("手机和座机至少填写一个"));
                            }
                            if(_self.formData.phone[0] === "" || _self.formData.phone[1] === ""){
                                callback(new Error("至少填写区号和座机号"));
                            }
                        }
                        if(_self.formData.phone[0] !== "" || _self.formData.phone[1] !== ""){
                            let patt = /^(0[0-9]{2,3})+\-([2-9][0-9]{6,7})+\-([0-9]+)?$/;
                            let allPhone = _self.formData.phone[0] + '-' + _self.formData.phone[1] + '-'+ _self.formData.phone[2];
                            if(!patt.test(allPhone)){
                                if(_self.formData.phone[0] !== "" && _self.formData.phone[1] !== ""){
                                    callback(new Error("请填写正确的座机号"));
                                }else{
                                    callback(new Error("至少填写区号和座机号"));
                                }
                            }    
                        }
                        callback();
                    },
                };
            },
            //获取权限
            getPageAuth(){
                this.pageAuth = utils.judgeAuth([baseAuthEnum.EDIT_COMPANY_INFO],1);
            },
            //获取单位图片列表并初始化单位图片及上传证明资料图
            getCompanyPicList(){
                let _self = this;
                $api.getCompanyPics().then(data=>{
                    _self.picList = data;
                    //初始化图片
                    for(let i = 0 ; i < data.length ; i++){
                        _self.$refs.companyPic.addFilesToFileList(data[i].id,data[i].name,data[i].url,data[i].check);
                    }
                });
            },
            /**
             * 删除联系人按钮
             * @param {int} index 待删除项的索引
             */
            deleteCard(index){
                this.formData.card.splice(index,1);
                this.formData.splice(0,1,this.formData);
            },
            //获取公司基本信息
            getCompanyBaseInfo(){
                let _self = this;
                this.pageLoading = true;
                $api.getCompanyInfo().then(data => {
                    _self.pageLoading = false;
                    _self.baseData = data.data;
                    _self.formData = this.adjustFormData(data);
                    _self.formData.phone = _self.formData.phone.split("-");
                    _self.companyId = data.id;
                    _self.type = data.type;
                    _self.setFormRule();
                    //调整主导产业数据格式
                    _self.$nextTick(()=> {
                        //获取并初始化单位图片及上传证明资料图
                        _self.getCompanyPicList();
                    });
                });
            },
            /**
             * 这里调整获取表单数据格式
             * @param {object} data 待调整的数据
             * @returns {Array}
             */
            adjustFormData(data){
                let arr = {};
                let list = data.data.list;
                for(let k=0;k<list.length;k++){
                    arr[list[k].name]=  list[k].value;
                }
                return arr;
            },
            /**
             * logo上传成功回调
             * @param {object} response 上传回调数据
             * @param {int} index 所属外层数组索引
             */
            logoUploadSuccess(response){
                let pic = response.data[0].domain+response.data[0].logo;
                this.formData = Object.assign(this.formData,{"logo":pic});
            },
            //上传logo失败回调
            logoUploadError(){
                utils.notice('上传失败','error');
            },
            //保存按钮点击事件
            doSave(){
                let res = true;
                //表单校验
                this.$refs.partoneForm.validate((valid) => {
                    if (!valid) {
                        res = false;
                    }
                });
                if(!res){
                    utils.notice("您还有信息未填写或未验证通过","error");
                    return false;
                }
                //整理结果
                let postData = this.getPostData();
                this.doPutData(postData);
            },
            /**
             * 公共ajaxPut提交
             * @param {object} data 待提交的数据
             * @returns {boolean}
             */
            doPutData(data){
                data.update_type = "1";
                let companyId = this.companyId;
                let _self = this;
                if(this.loadingStatus === true){
                    return false;
                }
                this.loadingStatus = true;
                $api.setCompanyBaseInfo(companyId,data).then(data=>{
                    _self.loadingStatus = false;
                    if(data.code === "200"){
                        utils.message({title:'保存成功'},"success");
                        _self.$router.push({
                            name : "companyinfo",
                        })
                    }else{
                        utils.message({title:data.msg},"error");
                    }

                });
            },
            //整理结果
            getPostData(){
                let data = this.formData;
                let res = {
                    "companyname": data.companyname ? data.companyname : "",
                    "logo" : data.logo ? utils.removeDomain(data.logo) : "",
                    "aliases" : data.aliases ? data.aliases : "",
                    "material_upload_ids" : data.material_upload_ids ? data.material_upload_ids.join(",") : "", //证明材料
                    "pic_upload_ids" : "",  //图片上传
                    "check_pic_id" : "",    //选中图片
                    "intro" : data.intro ? data.intro : "",
                    "mobile" : data.mobile ? data.mobile : "",
                    "phone" : data.phone.join("-") ? data.phone.join("-") : "",
                };
                //整理图片上传
                let pic = this.$refs.companyPic.getFileList();
                let picList = [];
                let checkPic = [];
                for(let i = 0;i<pic.length;i++){
                    picList.push(pic[i].id.toString());
                    if(pic[i].checked === true){
                        checkPic.push(pic[i].id.toString());
                    }
                }
                let checkPicStr = checkPic[0] ? checkPic[0] : (picList[0] ? picList[0] : "");
                let picListStr = picList.join(",");

                res.pic_upload_ids = picListStr;
                res.check_pic_id = checkPicStr;
                return res;
            },
        },
    }
</script>

<style>
    @import 'index.less';
    @import 'editother.less';
</style>


// WEBPACK FOOTER //
// src/pages/company/baseinfo/EditOther.vue